import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconAlertTriangle = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      ref={ref}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="yfm-icon yfm-icon-alert-triangle"
      {...omit(props, ["className"])}
    >
      <path d="M12 8v5m0 3h.01M10.3 3.8 2.6 17.2A2 2 0 0 0 4.3 20h15.4a2 2 0 0 0 1.7-2.8L13.7 3.8a2 2 0 0 0-3.4 0Z" />
    </svg>
  )
);

IconAlertTriangle.displayName = "IconAlertTriangle";

export default IconAlertTriangle;
